import DealerVendorListContent from "./DealerVendorListContent";

const DealerVendorListContentContainer = () =>{
    return (
        <DealerVendorListContent/>
    )
}

export default DealerVendorListContentContainer;